import React, { Component } from 'react';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import axios from 'axios';
import _ from 'lodash';

import Login from '../pages/auth/login/login';

import { validateToken } from '../pages/auth/authActions';

import ModuleAdmin from '../modules/admin/main/module-admin';

import 'react-redux-toastr/lib/css/react-redux-toastr.min.css';
import "../common/dependencies";
import '../assets/styles/main.scss';
import ModuleSystem from '../modules/system/main/module-system';
import moment from 'moment';
import Loading from '../common/components/ui/loading/loading';
import { setLoading } from '../helpers/redux';


class App extends Component {
	constructor(props){
		super(props);
		moment.locale('pt-br');

		axios.defaults.headers.common['Accept'] = 'application/json';
		// axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
	}

	componentWillMount() {
		const { userToken } = this.props.auth;
		if (userToken !== false && !_.isNull(userToken)) {
			this.props.setLoading('APPLICATION_LOADER', true);
			this.props.validateToken(userToken.token);
		}
	}

	render() {
		const { user, validToken } = this.props.auth;
		let prefix = this.props.location.pathname.split('/');
		if (!validToken || _.isNull(user)) {
			return (
				<React.Fragment>
					<Login />
					<Loading
						overlay={true}
                    	isVisible={this.props.loading}
                	/>
				</React.Fragment>
			);
		}

		if (prefix.length > 1) {
			prefix = prefix[1];
		} else {
			prefix = prefix[0];
		}

		if (prefix === 'admin') {
			return (
				<ModuleAdmin>
					{this.props.children}
				</ModuleAdmin>
			);
		} else {
			return (
				<ModuleSystem>
					{this.props.children}
				</ModuleSystem>
			);
		}
	}
}

const mapStateToProps = (state) => {
	return {
		auth: state.auth,
		loading: state.app.loading
	}
}

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({ validateToken, setLoading }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(App);